import * as React from 'react';

import { Typography } from '@mui/material';

import BaseDialog, { BaseDialogProps } from '../Base';
import { CancelReservationProps, ConfirmShipment } from './components/ConfirmShipment';

type CancelReservationsDialogProps = BaseDialogProps & CancelReservationProps;

const ConfirmShipmentDialog: React.FC<CancelReservationsDialogProps> = ({
  modalRef,
  reservationDetail,
  refetchReservationDetails,
  ...restProps
}) => {
  return (
    <BaseDialog width='550px' height='264px' titleComponent={<></>} {...restProps}>
      <ConfirmShipment
        modalRef={modalRef}
        reservationDetail={reservationDetail}
        refetchReservationDetails={refetchReservationDetails}
      />
    </BaseDialog>
  );
};

export default ConfirmShipmentDialog;
